import { useEffect, useState } from 'preact/hooks';
import { get } from '../../api';
import type { OpsLogEntry } from '../../types';
import { LcarsPanel } from '../layout/LcarsPanel';
import { LoadingSpinner } from '../shared/LoadingSpinner';

function getTagClass(action: string): string {
  const a = action.toLowerCase();
  if (a.includes('seed') || a.includes('research')) return 'lt-seed';
  if (a.includes('brief') || a.includes('planning')) return 'lt-brief';
  if (a.includes('draft') || a.includes('writing')) return 'lt-draft';
  if (a.includes('stage') || a.includes('editing')) return 'lt-stage';
  if (a.includes('publish')) return 'lt-pub';
  return 'lt-sys';
}

function getTagLabel(action: string): string {
  const a = action.toLowerCase();
  if (a.includes('seed') || a.includes('research')) return 'Seed';
  if (a.includes('brief') || a.includes('planning')) return 'Brief';
  if (a.includes('draft') || a.includes('writing')) return 'Draft';
  if (a.includes('stage') || a.includes('editing')) return 'Stage';
  if (a.includes('publish')) return 'Pub';
  return 'Sys';
}

function formatTime(timestamp: string): string {
  try {
    const d = new Date(timestamp);
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0) {
      return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
    }
    if (diffDays === 1) return 'Yest';
    if (diffDays < 7) return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  } catch {
    return '—';
  }
}

export function OpsLogPanel() {
  const [entries, setEntries] = useState<OpsLogEntry[] | null>(null);

  useEffect(() => {
    get<{ entries: OpsLogEntry[] }>('/api/ops-log?limit=20')
      .then((data) => setEntries(data.entries))
      .catch(console.error);
  }, []);

  return (
    <LcarsPanel color="var(--peach)" title="Operations" badge="LIVE">
      {!entries ? (
        <LoadingSpinner />
      ) : (
        <div class="log-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {entries.map((entry) => (
            <div class="log-row" key={entry.id}>
              <span class="log-time">{formatTime(entry.timestamp || entry.created_at)}</span>
              <span class={`log-tag ${getTagClass(entry.action)}`}>{getTagLabel(entry.action)}</span>
              <div class="log-text">
                <strong>{entry.agent}</strong> {entry.details || entry.action}
              </div>
            </div>
          ))}
        </div>
      )}
    </LcarsPanel>
  );
}
